import { render, staticRenderFns } from "./serviceOrder.vue?vue&type=template&id=0d988e3c&scoped=true"
import script from "./serviceOrder.vue?vue&type=script&lang=js"
export * from "./serviceOrder.vue?vue&type=script&lang=js"
import style0 from "./serviceOrder.vue?vue&type=style&index=0&id=0d988e3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d988e3c",
  null
  
)

export default component.exports